angular
    .module('lingoda.fields.file', [])
    .directive('lingFile', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'C',
                require: '^lingForm',
                link: function (scope, element, attrs, requestCtrl) {
                    var refreshImageSize = function () {
                        element.find('input').fileupload({
                            previewMaxWidth: element.outerWidth(),
                            previewMaxHeight: 480,
                        });
                    };

                    element
                        .find('input')
                        .fileupload(
                            $.extend(
                                {
                                    dataType: 'json',
                                    disableImageResize: /Android(?!.*Chrome)|Opera/.test(
                                        window.navigator && navigator.userAgent,
                                    ),
                                    dropZone: false,
                                    pasteZone: false,
                                    imageMinWidth: 400,
                                    imageMinHeight: 400,
                                    imageCrop: false,
                                    previewCrop: false,
                                    autoUpload: false,
                                    disableImageResize: false,
                                    previewOrientation: false,
                                    previewThumbnail: false,
                                    formData: function (e) {
                                        return false;
                                    },
                                },
                                attrs,
                            ),
                        )
                        .on('fileuploadprocessalways', function (e, data) {
                            var index = data.index,
                                file = data.files[index];

                            if (file.error) {
                                scope.$emit('mainMessages:add', {
                                    type: 'error',
                                    content: file.error,
                                });
                                scope.$applyAsync();
                            } else {
                                if (file.preview) {
                                    scope.file = file;
                                    scope.newFile = file;
                                    scope.$applyAsync();
                                }
                            }
                        })
                        .on('fileuploadsend', function () {
                            scope.fileUploading = true;
                            requestCtrl.disable();
                        })
                        .on('fileuploaddone', function (e, data) {
                            var result = requestCtrl.success(data.result, {
                                skipSet: true,
                            });
                            requestCtrl.enable();
                            scope.file = null;
                            scope.uploadedFiles = result.files;
                            scope.fileUploading = false;
                            scope.$apply();
                        })
                        .on('fileuploadfail', function () {
                            scope.fileUploading = false;
                            requestCtrl.failure({
                                skipSet: true,
                            });
                            requestCtrl.enable();
                            scope.$apply();
                        });

                    $timeout(refreshImageSize);
                    angular.element(window).bind('resize', refreshImageSize);

                    scope.$watch('uploadedFiles', function (files) {
                        scope.field = files;
                    });

                    scope.$watch('fileUploadOptions', function (options) {
                        if (options) {
                            element.find('input').fileupload('option', options);
                        }
                    });

                    scope.$on('ling:form:response:done', function () {
                        scope.file = null;
                    });

                    scope.setCroppedImage = function () {
                        scope.croppedImage.toBlob(function (blob) {
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onloadend = function () {
                                scope.setNewProfilePicture(reader.result);
                                scope.approvedFile = reader.result;
                                scope.newFile = null;
                                scope.$apply();
                            };
                        });
                    };

                    scope.removeFile = function () {
                        scope.removeNewProfilePicture();
                        scope.approvedFile = null;
                        scope.newFile = null;
                    };
                },
            };
        },
    ])

    .directive('fileOnChange', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChangeHandler = scope.$eval(attrs.fileOnChange);
                element.on('change', onChangeHandler);
                element.on('$destroy', function () {
                    element.off();
                });
            },
        };
    })
    .directive('lingFilePreview', function () {
        return {
            restrict: 'C',
            template:
                '' +
                '<div ling-loader ng-show="fileUploading"></div>' +
                '<div class="ling-file-preview-content"></div>',
            link: function (scope, element, attrs) {},
        };
    })
    .directive('lingFilePreviewContent', [
        '$timeout',
        function ($timeout) {
            return {
                restrict: 'C',
                link: function (scope, element) {
                    var jCrop = null,
                        img = null,
                        initJCrop = function (originalImg) {
                            var w = $(img).width(),
                                h = $(img).height(),
                                size = 0,
                                left = 0,
                                top = 0,
                                ratio = originalImg.width / w;

                            if (w > h) {
                                size = h;
                                left = (w - h) / 2;
                            } else {
                                size = w;
                                top = (h - w) / 2;
                            }

                            scope.coordinates = [left, top, size, size];
                            $(img).Jcrop(
                                {
                                    setSelect: scope.coordinates,
                                    minSize: [400 / ratio, 400 / ratio],
                                    allowSelect: false,
                                    keySupport: false,
                                    aspectRatio: 1,
                                    onSelect: function (coords) {
                                        scope.coordinates = coords;
                                    },
                                },
                                function () {
                                    jCrop = this;
                                },
                            );
                        };
                    scope.$watch('file', function (file) {
                        if (file) {
                            img = file.preview;
                            element.html(img);
                            loadImage(file, function (originalImg) {
                                $timeout(function () {
                                    initJCrop(originalImg);
                                });
                            });
                        } else {
                            element.html('');
                        }
                    });
                    scope.$watch('fileUploading', function (v) {
                        if (jCrop) {
                            if (v) {
                                jCrop.disable();
                            } else {
                                jCrop.enable();
                            }
                        }
                    });
                },
            };
        },
    ])
    .directive('lingNewFileCropped', function () {
        return {
            restrict: 'C',
            link: function (scope, element) {
                scope.$watch('coordinates', function (coordinates) {
                    if (coordinates) {
                        loadImage(scope.newFile, function (originalImg) {
                            var cropImg = scope.newFile.preview,
                                ratio = originalImg.width / $(cropImg).width();

                            loadImage(
                                scope.newFile,
                                function (img) {
                                    element.html(img);
                                    scope.croppedImage = img;
                                    scope.$apply();
                                },
                                {
                                    canvas: true,
                                    orientation: true,
                                    left: coordinates.x * ratio,
                                    top: coordinates.y * ratio,
                                    sourceWidth: coordinates.w * ratio,
                                    sourceHeight: coordinates.h * ratio,
                                },
                            );
                        });
                    }
                });
                scope.$watch('newFile', function (file) {
                    if (!file) {
                        element.html('');
                    }
                });
            },
        };
    })
    .directive('lingFileUploaded', function () {
        return {
            restrict: 'C',
            link: function (scope, element, attrs) {
                var defaultFile =
                        scope.uploadedFiles && scope.uploadedFiles.length
                            ? scope.uploadedFiles
                            : [
                                  {
                                      id: null,
                                      url: attrs.defaultFile || '',
                                      thumbnailUrl: attrs.defaultFile || '',
                                      thumbnail2xUrl: attrs.defaultFile || '',
                                      mediumUrl: attrs.defaultFile || '',
                                      medium2xUrl: attrs.defaultFile || '',
                                      name: '',
                                  },
                              ],
                    setDefaultFile = function () {
                        scope.uploadedFiles = defaultFile;
                    };

                setDefaultFile();
            },
        };
    });
